import { render } from "./InventoryDropDownSearch.vue?vue&type=template&id=62b5d360"
import script from "./InventoryDropDownSearch.vue?vue&type=script&lang=js"
export * from "./InventoryDropDownSearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__